import {
  React,
  Component,
  Redirect,
} from 'imports/CommonImports';

import {Login} from 'imports/ComponentsImports';

export default class Landing extends Component {
  render() {
    return (
      this.props.getCookie('token')
      ?
      <Redirect to="/home"/>
      :
      <Login registerCookie={this.props.registerCookie} history={this.props.history}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/template/Landing.js